const fromdata = [{
		inputdata: "",
		title: "经销商编码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		disabled: false,
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "客户名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		btx: true,
	},
	{
		inputdata: "",
		title: "客户类型",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "select",
		width: "220px",
		btx: true,
		options: [],
	},
	{
		inputdata: "",
		title: "曾用名",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
	},
	{
		inputdata: "",
		title: "上级经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectMultiple",
		width: "220px",
		btx: false,
		options: [],
		disabled: false,
	},
	{
		inputdata: "",
		title: "省份",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "province",
		width: "220px",
		btx: false,
		lablewith: "90px",
		options: [],
	},
	{
		inputdata: "",
		title: "城市",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "city",
		width: "220px",
		btx: false,
		lablewith: "80px",
		options: [],
	},
	{
		inputdata: "",
		title: "区县",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "area",
		width: "220px",
		btx: false,
		lablewith: "80px",
		options: [],
	},
	{
		inputdata: "",
		title: "地址",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "525px",
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "是否启用",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "text",
		inputtype: "radio",
		width: "210px",
		radio: "1",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: "90px",
	},

	{
		inputdata: "",
		title: "经营地址",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "法人代表",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		// lablewith: '90px'
	},
	{
		inputdata: "",
		title: "仓库地址",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		// lablewith: '90px'
	},
	{
		inputdata: "",
		title: "经营许可证",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "起始时间",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		widths: "223px",
	},
	{
		inputdata: "",
		title: "有效期至",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		lablewith: "100px",
		widths: "223px",
	},
	{
		inputdata: "",
		title: "备案凭证编号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "起始时间",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		widths: "223px",
		// lablewith: '95px'
	},
	{
		inputdata: "",
		title: "有效期至",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		widths: "223px",
		lablewith: "100px",
	},
	{
		inputdata: "",
		title: "手机号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		lablewith: "90px",
	},
	{
		inputdata: "",
		title: "Email",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "210px",
		widths: "210px",
		lablewith: "80px",
	},
	{
		inputdata: "",
		title: "库存不展示",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "text",
		inputtype: "radio",
		width: "210px",
		radio: "1",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: "90px",
	},
	{
		inputdata: false,
		title: '仅授权不订货',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: '',
		inputtype: 'checkboxs',
		checkboxdata: [{
			label: "1",
			value: ""
		}],
		width: '0px',
		lablewith: '120px',
	},
	{
		inputdata: '',
		title: '上游二级经销商',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'selectautocompletemultiple',
		width: '210px',
		btx: false,
		lablewith: '220px',
		options: [],
		pt: true,
		disabled: true
	}
];
export default fromdata;